import React from 'react';
import PropTypes from 'prop-types';
import { replaceSpacesWithDashes } from '../../../../_modules/string/replace_spaces_with_dashes';
import { generateClassName } from '../../../../_modules/helper/generate_class_name';
import { replaceWithOptionalManufacturerTranslation }
    from '../../../../_modules/translation/replace_with_optional_manufacturer_translation';

const generateTextualClassNames = modifier => generateClassName({
    'brand-logo': true,
    'brand-logo--textual': true,
    'logos-to-hide-text': ['bridgestone', 'firestone'].indexOf(modifier.toLowerCase()) !== -1,
    ['brand-logo--' + modifier]: true,
})();

export const Textual = ({ manufacturer }) => {
    const translatedManufacturer = replaceWithOptionalManufacturerTranslation(manufacturer);
    const classNameModifier = replaceSpacesWithDashes(translatedManufacturer).toLowerCase();
    const classNames = generateTextualClassNames(classNameModifier);

    return (
        <span className={classNames}>
            {translatedManufacturer}
        </span>
    );
};

Textual.propTypes = {
    manufacturer: PropTypes.string.isRequired,
};
